export default {
  namespaced: true,

  state: {
    info: null
  },

  mutations: {
    set(state: any, payload: any) {
      state.info = payload;
    },
    remove(state: any) {
      state.info = null;
    }
  },

  actions: {
    set(context: any, payload: any) {
      context.commit("set", payload);
    },
    remove(context: any) {
      context.commit("remove");
    }
  },

  getters: {
    info: (state: any): boolean => state.info
  }
};
